import React from 'react';

import { ApolloClient, ApolloProvider, InMemoryCache } from '@apollo/client';
import { SchemaLink } from '@apollo/client/link/schema';
import { ThemeProvider } from '@emotion/react';
import { ThemeProvider as Tp, createTheme } from '@mui/material/styles';
import ReactDOM from 'react-dom/client';
import { ToastContainer } from 'react-toastify';
import { RecoilRoot } from 'recoil';

import theme from '@styles/theme';

import schema from '@apis/graphql/schema';

import App from './App';
import reportWebVitals from './reportWebVitals';

import 'react-toastify/dist/ReactToastify.css';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

/** GraphQL Init */
const graphqlClient = new ApolloClient({
  cache: new InMemoryCache(),
  link: new SchemaLink({ schema }),
});

root.render(
  <React.StrictMode>
    <RecoilRoot>
      <ThemeProvider theme={theme}>
        <ApolloProvider client={graphqlClient}>
          <Tp theme={createTheme({})}>
            <App />
          </Tp>
        </ApolloProvider>
      </ThemeProvider>
      <ToastContainer
        autoClose={2000}
        pauseOnHover={false}
        position={'bottom-right'}
        pauseOnFocusLoss={false}
      />
    </RecoilRoot>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
